import { Inject, Injectable } from "@angular/core";
import { FLAT_SETTINGS, type SettingControlModel } from "./api.control.service";

@Injectable({
    providedIn: 'root',
})
export class AuthControlService {

    redirectStorageKey = 'medsurf-redirect-url';

    constructor(
        @Inject(FLAT_SETTINGS) private settings: SettingControlModel
    ) {}

    public getRedirectUrl() {
        return sessionStorage.getItem(this.redirectStorageKey) ?? window.location.origin;
    }

    public getRedirectRoute() {
        const url = this.getRedirectUrl();
        if (!url) return ['/'];
        return url.split('/').slice(3);
    }

    public setRedirectUrl(url: string) {
        return sessionStorage.setItem(this.redirectStorageKey, url);
    }


    public getOidcAuthLoginUrl() {
        return `${this.settings.endpointUrl}auth/login?redirect=${this.getRedirectUrl()}`;
    }

    public oidcAuthLogin() {
        const loginUrl = this.getOidcAuthLoginUrl();
        window.open(loginUrl, '_self');
    }

    public oidcAuthLogout() {
        const logoutUrl = `${this.settings.endpointUrl}auth/logout?redirect=${this.getRedirectUrl()}`;
        window.location.href = logoutUrl;
    }

    public oidcAuthUserProfileRedirect() {
        const logoutUrl = `${this.settings.endpointUrl}auth/user-profile?redirect=${this.getRedirectUrl()}`;
        window.location.href = logoutUrl;
    }
}